import { CurriculumCountryCodes } from '../constants/curriculum.const'

/**
 * Resolves the flag asset for a curriculum country code.
 *
 * Two quirks are baked in and must not be "simplified" away:
 *  - Florida has no flag of its own and reuses the US one.
 *  - The default International logo is black, so dark surfaces (site footer, dark menu) need the
 *    `-footer` light variant instead.
 *
 * Shared by CurriculumDropdownItem and the footer's collapsed trigger, which cannot reuse that
 * component because it renders a <button> and the trigger is itself a button.
 */
export function getCurriculumFlagSrcKey(curriculumCountryCode: string, isOnDarkSurface?: boolean): string {
  // Empty on first paint, before geo-location resolves. Without this the URL is `country-flags-rect/.svg`,
  // which fails, and <picture> keeps the broken source even once the real code arrives.
  const countryCode = curriculumCountryCode?.trim() || CurriculumCountryCodes.DEFAULT
  const flagCountryCode = countryCode === CurriculumCountryCodes.FLORIDA ? CurriculumCountryCodes.USA : countryCode
  const isInternationalOnDark = isOnDarkSurface && countryCode === CurriculumCountryCodes.DEFAULT
  return `country-flags-rect/${flagCountryCode.toUpperCase()}${isInternationalOnDark ? '-footer' : ''}.svg`
}
